import React, { useEffect } from "react";
import { observer } from "mobx-react";

import { Typography } from "@material-ui/core";
import zIndex from "@material-ui/core/styles/zIndex";

import { useStore } from "../../store";
import { convertStringToHashTagHtml } from "../../utils/convert";
import { BackdropPanel } from "../../components";
import { MoreInfoContainer, DetailGlobalStyle } from "./style";
import { useParams } from "react-router-dom";
const DetailPanelInfo = () => {
  const {
    detailStore: {
      infoState: { title, description, isMoreInfo },
      onResetInfoState,
    },
  } = useStore();
  const { id } = useParams<{ id: string }>();

  // unmounted 시 infoState 초기화
  useEffect(() => {
    return () => {
      onResetInfoState();
    };
    // eslint-disable-next-line
  }, []);
  const jsonParams = {
    project_id: id,
  };

  const convertDesc = description
    ? convertStringToHashTagHtml(description, jsonParams)
    : "";

  return (
    <BackdropPanel
      isOpen={isMoreInfo}
      style={{
        alignItems: "flex-end",
        zIndex: zIndex.drawer + 2,
      }}
    >
      <DetailGlobalStyle />
      <MoreInfoContainer dir="auto">
        <Typography className="info-title" variant="h5">
          {title}
        </Typography>
        <Typography
          variant="body2"
          component="span"
          className="info-description"
        >
          {convertDesc}
        </Typography>
      </MoreInfoContainer>
    </BackdropPanel>
  );
};

export default observer(DetailPanelInfo);
